type SentryModule = typeof import("@sentry/react");

let sentry: SentryModule | undefined;

/**
 * Loads and initializes Sentry after the app's first render (prod only, see main.tsx) —
 * a dynamic import so the SDK is neither bundled eagerly nor fetched at all outside prod.
 */
export function initSentry() {
	if (import.meta.env.VITE_ENV !== "prod") return;
	import("@sentry/react").then((mod) => {
		sentry = mod;
		mod.init({
			dsn: "https://c51c5d1faf5e11211c52a71c8d68a45f@o4511876665901056.ingest.us.sentry.io/4511876673241088",
			dataCollection: {
				// To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
				// https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
				// userInfo: false,
				// httpBodies: []
			},
			// Enable logs to be sent to Sentry
			enableLogs: true,
			integrations: [mod.replayIntegration()],
			// Session Replay
			replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
		});
	});
}

/** No-op until `initSentry()`'s dynamic import resolves, or outside prod. */
export function captureException(
	error: unknown,
	context?: Parameters<SentryModule["captureException"]>[1],
) {
	sentry?.captureException(error, context);
}
